import { Network } from "@dcl/schemas";
const networksNames = {
    [Network.ETHEREUM]: "Ethereum",
    [Network.MATIC]: "Polygon",
    [Network.ARBITRUM]: "Arbitrum",
    [Network.AVALANCHE]: "Avalanche",
    [Network.FANTOM]: "Fantom",
    [Network.BSC]: "Binance Smart Chain",
    [Network.OPTIMISM]: "Optimism",
};
const getNetworkName = (network) => networksNames[network];
const getNetworkMANADescription = (network) => {
    const networkName = getNetworkName(network);
    return networkName ? `${networkName} MANA` : `MANA`;
};
export { getNetworkMANADescription, getNetworkName, networksNames, };
//# sourceMappingURL=network.js.map